import { render } from "react-dom";

import App from "./App";

import "semantic-ui-css/semantic.min.css";


const MOUNT_NODE = document.getElementById("root");

const renderApp = () =>
  render(
    <App />,
    MOUNT_NODE
  );
renderApp();
